jQuery( document ).ready(function() {
    let $ = jQuery;
    var slickElement = $('.sports_news_or_events .news-wrapper');

    if( slickElement.length ) {
        slickElement.slick({
            // autoplay: true,
            slidesToShow: 3,
            infinite: true,
            arrows: true,
            rows: 0,
            speed: 300,
            swipeToSlide: true,
            focusOnSelect: true,

            responsive: [
              {
                breakpoint: 1248,
                settings: {
                  slidesToShow: 2
                }
              },
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 1
                }
              },
            ]
        });
    }
});